module.exports = __webpack_public_path__ + "assets/img/f9af0c2c67711deb27d832a0da744e33.png";